var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"widget-asc-desc",on:{"click":_vm.onClick}},[(_vm.type == 1)?_c('img',{attrs:{"src":require("@/assets/icon/asc.svg")}}):_c('img',{attrs:{"src":require("@/assets/icon/desc.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }